module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.isInitial || _vm.isSaving) ? _c('div', {
    staticClass: "dropbox"
  }, [_c('input', {
    staticClass: "input-file",
    attrs: {
      "type": "file",
      "id": "file",
      "multiple": "",
      "name": _vm.uploadFieldName,
      "disabled": _vm.isSaving
    },
    on: {
      "change": function($event) {
        return _vm.filesChange($event.target.name, $event.target.files)
      }
    }
  }), _vm._v(" "), (_vm.isInitial) ? _c('div', {
    staticClass: "center"
  }, [_c('i', {
    staticClass: "icon-cloud-upload"
  }), _vm._v(" "), _c('p', [_vm._v("Arraste seu arquivo aqui")]), _vm._v(" "), _c('p', [_vm._v("ou")]), _vm._v(" "), _vm._m(0)]) : _vm._e(), _vm._v(" "), (_vm.isSaving) ? _c('p', {
    staticClass: "center"
  }, [_vm._v("\n      Salvando...\n    ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.isSuccess) ? _c('div', [_c('i', {
    staticClass: "icon-file-check2"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.fileName))]), _vm._v(" "), _c('i', {
    staticClass: "icon-cross",
    on: {
      "click": function($event) {
        return _vm.reset()
      }
    }
  })]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('button', {
    staticClass: "btn btn--success"
  }, [_vm._v("Buscar no computador")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-205dfc80","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/template/UploadFile.vue
// module id = 2970
// module chunks = 0